<template>
  <div>
    <div class="template-item">
      <div class="w1200" style="padding-top: 148px">
        <div class="home-item-title">
          <div
            style="
              font-weight: 700;
              font-size: 50px;
              color: #1d2129;
              line-height: 50px;
            "
          >
            CLoud—灵活搭建CRM
          </div>
          <div
            style="
              font-size: 24px;
              color: #333333;
              line-height: 40px;
              margin-top: 30px;
              width: 436px;
            "
          >
            智能化可配置CRM系统，随需而变，赋能销售团队。
          </div>
          <div class="home-item-input">
            <el-input
              v-model="phone"
              placeholder="请输入您的手机号码"
            ></el-input>
            <div class="home-item-btn center">立即体验</div>
          </div>
        </div>
      </div>
      <img
        src="https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2025/11/27/解决方案@2x-180235830.png"
        alt=""
      />
    </div>

    <div>
      <div class="w1200" style="padding: 86px 0 80px">
        <div
          style="
            font-weight: 500;
            font-size: 40px;
            color: #1d2129;
            line-height: 40px;
            text-align: center;
          "
        >
          CRM 全域智联
        </div>

        <div class="between" style="margin-top: 60px">
          <div
            v-for="item in 4"
            :key="item"
            style="
              width: 242px;
              height: 280px;
              position: relative;
              box-shadow: 2px 2px 14px 0px rgba(55, 99, 170, 0.1);
              border-radius: 8px 8px 8px 8px;
              flex-direction: column;
              padding: 0 23px;
            "
            class="center"
          >
            <img
              src="https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2025/11/27/矩形 211@2x (1)-185138175.png"
              alt=""
              style="
                position: absolute;
                top: 0;
                left: 0;
                height: 100%;
                width: 100%;
                object-fit: cover;
                z-index: -1;
              "
            />

            <img
              src="https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2025/11/27/灵活自定义@2x-185227877.png"
              alt=""
              style="width: 60px; height: 60px"
            />
            <div
              style="
                font-weight: 500;
                font-size: 18px;
                color: #1d2129;
                line-height: 20px;
                margin-top: 35px;
              "
            >
              灵活自定义
            </div>
            <div
              style="
                text-align: center;
                font-size: 14px;
                color: #636e80;
                line-height: 20px;
                margin-top: 25px;
              "
            >
              融合专业CRM功能与灵活搭建，让您随心构建贴合自身流程的业务系统
            </div>
          </div>
        </div>
      </div>
    </div>

    <div style="background: #f5f8ff">
      <div class="w1200" style="padding: 80px 0">
        <div
          style="
            font-weight: 500;
            font-size: 40px;
            color: #1d2129;
            line-height: 40px;
            text-align: center;
          "
        >
          CRM场景功能
        </div>

        <div class="between" style="margin-top: 40px">
          <div
            v-for="(item, index) in tabs"
            :key="item.title"
            class="center tabs-title"
            :class="{ active: activeTab === index }"
            @click="activeTab = index"
          >
            {{ item.title }}
          </div>
        </div>
        <div class="between" style="margin-top: 50px">
          <div class="flex" style="flex-direction: column; gap: 16px">
            <div
              v-for="text in tabs[activeTab].content"
              :key="text"
              class="flex"
              style="gap: 10px; align-items: center"
            >
              <img
                src="https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2025/11/28/序号@2x-095521383.png"
                alt=""
                style="width: 12px; height: 12px"
              />
              <span>{{ text }}</span>
            </div>

            <div
              style="
                width: 130px;
                height: 40px;
                background: #2e98fe;
                border-radius: 6px;
                margin-top: 20px;
                font-size: 16px;
                color: #ffffff;
                line-height: 24px;
                text-align: left;
                cursor: pointer;
              "
              class="center"
              @click="$router.push('/')"
            >
              立即试用
            </div>
          </div>
          <div
            style="
              width: 542px;
              height: 304px;
              background: #ffffff;
              box-shadow: 0px 2px 6px 0px rgba(183, 189, 202, 0.2);
              border-radius: 6px;
              border: 8px solid #f6f6f6;
            "
          ></div>
        </div>
      </div>
    </div>

    <div>
      <div class="w1200" style="padding: 80px 0 114px; position: relative">
        <div
          style="
            font-weight: 500;
            font-size: 40px;
            color: #1d2129;
            line-height: 40px;
            text-align: center;
          "
        >
          CRM场景功能
        </div>
        <div class="between" style="margin-top: 50px">
          <div
            style="
              width: 542px;
              height: 304px;
              background: #ffffff;
              box-shadow: 0px 2px 6px 0px rgba(183, 189, 202, 0.2);
              border-radius: 6px;
              border: 8px solid #f6f6f6;
            "
          ></div>
          <div class="customTabs">
            <div
              v-for="(item, index) in customTabs"
              :key="item.title"
              style="text-align: right"
              @mouseenter="activeCustomTab = index"
              class="customTabs-item"
              :class="{ active: activeCustomTab === index }"
            >
              <div style="font-size: 20px; color: #1d2129; line-height: 20px">
                {{ item.name }}
              </div>
              <div
                v-if="activeCustomTab === index"
                style="
                  font-size: 16px;
                  color: #636e80;
                  line-height: 24px;
                  margin-top: 16px;
                "
              >
                {{ item.text }}
              </div>
            </div>
          </div>
        </div>

        <div
          style="
            width: 130px;
            height: 40px;
            background: #2e98fe;
            border-radius: 6px;
            font-size: 16px;
            color: #ffffff;
            line-height: 24px;
            text-align: left;
            cursor: pointer;
            position: absolute;
            right: 0;
            bottom: 80px;
          "
          class="center"
          @click="$router.push('/')"
        >
          立即试用
        </div>
      </div>
    </div>

    <div class="footer">
      <div
        style="
          font-weight: 500;
          font-size: 40px;
          color: #1d2129;
          line-height: 44px;
        "
      >
        立即创建您的专属CRM系统，开启业务新篇章
      </div>
      <div class="center" style="margin-top: 44px">
        <div
          style="
            width: 168px;
            height: 48px;
            background: #2e98fe;
            border-radius: 6px 6px 6px 6px;
            font-weight: 500;
            font-size: 20px;
            color: #ffffff;
            line-height: 48px;
            cursor: pointer;
          "
          class="hover-btn"
          @click="$router.push('/')"
        >
          <span style="margin-right: 12px">立即试用</span
          ><i class="el-icon-arrow-right"></i>
        </div>
      </div>

      <img
        src="https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2025/11/26/za@2x-180518035.png"
        alt=""
        class="home-item-left"
      />
      <img
        src="https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2025/11/26/yb@2x-180518028.png"
        alt=""
        class="home-item-right"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "Scheme",
  data() {
    return {
      phone: "",
      tabs: [
        {
          title: "客户管理",
          content: [
            "建立360°客户统一档案",
            "跟踪管理客户全生命周期（从线索到成交）",
            "客户分组与标签化细分",
            "管理客户公司内的多个联系人及关系",
          ],
          imgs: "",
        },
        {
          title: "营销管理",
          content: [
            "建立360°客户统一档案",
            "跟踪管理客户全生命周期（从线索到成交）",
            "客户分组与标签化细分",
            "管理客户公司内的多个联系人及关系",
          ],
          imgs: "",
        },
        {
          title: "售后管理",
          content: [
            "建立360°客户统一档案",
            "跟踪管理客户全生命周期（从线索到成交）",
            "客户分组与标签化细分",
            "管理客户公司内的多个联系人及关系",
          ],
          imgs: "",
        },
        {
          title: "订单管理",
          content: [
            "建立360°客户统一档案",
            "跟踪管理客户全生命周期（从线索到成交）",
            "客户分组与标签化细分",
            "管理客户公司内的多个联系人及关系",
          ],
          imgs: "",
        },
        {
          title: "数据可视化",
          content: [
            "建立360°客户统一档案",
            "跟踪管理客户全生命周期（从线索到成交）",
            "客户分组与标签化细分",
            "管理客户公司内的多个联系人及关系",
          ],
          imgs: "",
        },
      ],
      activeTab: 0,
      customTabs: [
        {
          name: "自定义表单字段",
          text: "客户、市场等核心模块可按需调用，实现功能的自由增删与修改",
        },
        {
          name: "自定义功能模块",
          text: "客户、市场等核心模块可按需调用，实现功能的自由增删与修改",
        },
        {
          name: "自定义业务流程",
          text: "客户、市场等核心模块可按需调用，实现功能的自由增删与修改",
        },
      ],
      activeCustomTab: 1,
    };
  },
};
</script>

<style lang="less" scoped>
.template-item {
  height: 565px;
  position: relative;
  img {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    object-fit: cover; /* 让图像覆盖整个容器 */
    z-index: -1;
  }

  .home-item-input {
    margin-top: 40px;
    display: flex;
    align-items: center;
    width: 291px;
    height: 44px;
    background: #ffffff;
    border-radius: 6px 6px 6px 6px;
    padding-right: 4px;

    .el-input {
      flex: 1;
      border-radius: 10px;
      border-color: #e5e5e5;
      background-color: #f5f5f5;
      ::v-deep .el-input__inner {
        border: unset;
      }
    }
    .home-item-btn {
      width: 100px;
      height: 36px;
      background: #2e98fe;
      border-radius: 4px;
      color: #fff;
    }
  }
}

.tabs-title {
  width: 211px;
  height: 42px;
  background: #ffffff;
  border-radius: 6px;
  font-size: 18px;
  color: #1d2129;
  line-height: 20px;
  cursor: pointer;
  &.active {
    background: #2e98fe;
    color: #ffffff;
  }
}

.customTabs {
  display: flex;
  flex-direction: column;
  padding-top: 16px;
  gap: 40px;
  height: 304px;
  .customTabs-item {
    transition: padding 0.1s;
    cursor: pointer;
    &.active {
      width: 386px;
      height: 126px;
      background: linear-gradient(
        360deg,
        #ffffff 0%,
        #f9fafc 66%,
        #f1f3f9 100%
      );
      box-shadow: 4px 4px 14px 0px rgba(183, 189, 202, 0.2);
      border-radius: 6px 6px 6px 6px;
      border: 2px solid #ffffff;
      padding: 20px;
    }
  }
}

.footer {
  height: 360px;
  text-align: center;
  padding-top: 112px;
  background: no-repeat
    url("https://ybr-file.oss-cn-shanghai.aliyuncs.com/ylab/resume/2025/11/26/矩形 1134@2x-180305440.png");
  position: relative;
  .home-item-left {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
  }
  .home-item-right {
    position: absolute;
    top: 0;
    right: 0;
    height: 100%;
  }
}

.hover-btn {
  i {
    transition: all 0.1s ease-in-out;
  }
  &:hover {
    i {
      transform: translateX(10px);
    }
  }
}
</style>